import React, { } from "react";
import { Button } from "reactstrap";
import "./index.scss";
const Item = ({ className = '', fullDetail = false }) => {

    return (
        <>
            <Button color="link" className={`text-start d-inline-flex notification-item ${className}`}>
                <span className='pic-cell rounded-circle flex-shrink-0 position-relative'>
                    <img className='img-fluid w-100 h-100 rounded-circle' src={require('../../../../assets/img/icons/user.png')} alt='User' />
                    <span className="icon rounded-circle bg-success position-absolute"></span>
                </span>
                <span className="info flex-fill">

                    Congratulate <strong>Socrates Itumay</strong> for work anniversaries.
                    {
                        fullDetail ? <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span> : ''
                    }

                    <span className='d-block time'>Mar 15 12:32pm</span>
                </span>
            </Button>
        </>
    )
};
export default Item;